"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debuggerIgnoredComponentsSet = exports.setFont = exports.TagName = void 0;
const styled_components_1 = require("styled-components");
var TagName;
(function (TagName) {
    TagName["Image"] = "IMG";
    TagName["Video"] = "VIDEO";
    TagName["Button"] = "BUTTON";
})(TagName = exports.TagName || (exports.TagName = {}));
const setFont = (font) => (0, styled_components_1.css) `
  font-style: ${font === null || font === void 0 ? void 0 : font.fontStyle};
  font-family: ${font === null || font === void 0 ? void 0 : font.fontFamily};
  font-size: ${font === null || font === void 0 ? void 0 : font.fontSize};
  line-height: ${font === null || font === void 0 ? void 0 : font.lineHeight};
  text-rendering: ${font === null || font === void 0 ? void 0 : font.textRendering};
`;
exports.setFont = setFont;
exports.debuggerIgnoredComponentsSet = new Set(['canvas-container', 'canvas-item']);
